import { Overview } from "./Overview";
import "./styles.scss";

export default {
  Overview,
};
